import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Api from "services/api"


export const initialState = {
  actionButtons: {},
  error: null,
  loader: false,
}

export const actionButtonsSlice = createSlice({
  name: 'actionButtons',
  initialState: initialState,
  reducers: {
    // setActionButtons: (state, { payload }) => {
    //   state.actionButtons = payload?.data ?? payload;
    //   state.total = payload?.total;
    //   state.is_more = payload?.is_more;
    //   state.last_page = payload?.last_page;
    // },
    // setActionButtonss: (state, { payload }) => {
    //   state.actionButtons = payload?.data;
    //   state.total = payload?.total;
    //   state.is_more = payload?.is_more;
    //   state.last_page = payload?.last_page;
    // },
    // setMoreActionButtonss: (state, { payload }) => {
    //   state.data = state.data.concat(payload.data);
    //   state.total = payload.total;
    //   state.is_more = payload.is_more;
    //   state.last_page = payload?.last_page;
    // },
    // removeActionButtons: (state, { payload }) => {
    //   state.error = payload
    // },
    // clearAllActionButtons: (state, { payload }) => {
    //   state.loader = payload
    // },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const setActionAssign = (id, data, endpoint, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    console.log("id, data, endpoint", id, data, endpoint);

    const json = await Api.setActionAssign(id, data, endpoint)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCalendar(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const setInterpreterActionAssign = (id, data, endpoint, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    console.log("id, data, endpoint", id, data, endpoint);

    const json = await Api.setInterpreterActionAssign(id, data, endpoint)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCalendar(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const setVendorActionAssign = (id, data, endpoint, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {
    console.log("id, data, endpoint", id, data, endpoint);

    const json = await Api.setVendorActionAssign(id, data, endpoint)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCalendar(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}


export const inviteInterpretersActions = (id, data, endpoint, callback) => async (dispatch) => {
  const apiService = new Api();
  // dispatch(setError({}))
  // dispatch(setLoader(true))
  try {
    const json = await Api.inviteInterpretersActions(id, data, endpoint)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setCalendar(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  // dispatch(setLoader(false))
}

export const declineAppointments = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.declineAppointments(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      // dispatch(setInterpreter(json.data))
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
    // callback(false)

  }
  dispatch(setLoader(false))
}

export const { setLoader, setError, } = actionButtonsSlice.actions


export default actionButtonsSlice.reducer
export const actionButtonsSelector = state => state.actionButtons


